
import { ref, Ref, watch, SetupContext } from "vue";
import { VugelMouseEvent, Node } from "vugel";

export default {
    props: {
        description: { type: String, default: "" },
    },
};
